/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { POST } from '/client/src/api';
import Credentials from '/client/src/api/Credentials.js';
import withMeta from '/client/src/HOCs/withMeta';
import t from 'client/src/utils/i18nCheckKey';
import { ToggleOpacityOfContent } from 'client/src/utils/animation';
import BtnLoader from '/client/src/components/btns/circularProgress/';

type PropsType = {
  handleChangeView: (string) => void,
  toggleAuthenticateStatus: () => void
};

const Login = (props: PropsType): React.Element<typeof React.Fragment> => {
  const [ login, setLogin ] = React.useState('');
  const [ pass, setPass ] = React.useState('');
  const [ rememberMe, setRememberMe ] = React.useState(false);
  const [isIncorrect, setIncorrect] = React.useState(false);

  const loginValidationMessage = React.createRef();
  const passValidationMessage = React.createRef();

  ToggleOpacityOfContent(1);

  const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    validate('login', login);
    validate('pass', pass);

    if (!_.size(login) || !_.size(pass)) {
      return false;
    }

    try {
      setStatus('loading');
      const { user, token } = await POST('/auth', {
        email: login,
        password: pass
      });

      setStatus('success');
      ToggleOpacityOfContent(0);

      setTimeout(() => {
        Credentials.login(token, user, rememberMe);

        setTimeout(() => {
          props.toggleAuthenticateStatus(true);
        }, 500);
      }, 500);
    } catch (error) {
      setStatus('error');
      console.error(error);

      setIncorrect(error);

      setTimeout(() => {
        setStatus('');
      }, 5000);
    }
  };


  const validate = (key: string, value: string | null) => {
    const loginWrapper = loginValidationMessage.current;
    const passWrapper = passValidationMessage.current;

    if (key === 'login') {
      if (!_.size(value)) {
        loginWrapper.classList.add('has-error');
        loginWrapper.querySelector('input').classList.add('validationElement');
      } else {
        loginValidationMessage.current.classList.remove('has-error');
        loginValidationMessage.current
          .querySelector('input')
          .classList
          .remove('validationElement');
      }
    }

    if (key === 'pass') {
      if (!_.size(value)) {
        passWrapper.classList.add('has-error');
        passWrapper.querySelector('input').classList.add('validationElement');
      } else {
        passValidationMessage.current.classList.remove('has-error');
        passValidationMessage.current
          .querySelector('input')
          .classList
          .remove('validationElement');
      }
    }
  };

  return (
    <div className="form-box-container">
      <div className="form-box-message">
        <h3 className="auth-message-header">{t('Login to Sparxo')}</h3>
        <div className="auth-message-desc">Enter your account details below.</div>

        {isIncorrect &&
          <div className="alert alert-danger mt-3">
            <div data-bind="text: errorMessage">
              {isIncorrect.data?.error_description || 'Your email or password is incorrect.'}
              Do you need to <Link to='/reset-password'>reset your password</Link> or <Link to='/sign-up'>create an account</Link>?
            </div>
          </div>
        }
      </div>
      <form className="mt-5" role="form">
        <div className="mt-4">
          <label htmlFor="email">Email</label>
          <div ref={loginValidationMessage}>
            <input
              className="form-control validationElement"
              type="email"
              title="This field is required."
              value={login}
              onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                setLogin(e.target.value);

                validate('login', e.target.value);
              }}
            />
            <span
              className="validationMessage"
            >This field is required.</span>
          </div>
        </div>

        <div className="mt-4">
          <div className="pswd-label">
            <label htmlFor="password">Password</label>
            <a
              href="#"
              onClick={(e: SyntheticEvent<HTMLLinkElement>) => {
                e.preventDefault();

                props.handleChangeView('/reset-password');
              }}
            >
              Reset password
            </a>
          </div>
          <div ref={passValidationMessage}>
            <div className="input-group">
              <input
                className="form-control validationElement"
                type="password"
                title="This field is required."
                id="password"
                value={pass}
                onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                  setPass(e.target.value);

                  validate('pass', e.target.value);
                }}
              />
              <span
                  className="input-group-addon"
                  onClick={(e: any) => {
                    const inputEl = e.currentTarget.previousSibling;
                    const icon = e.currentTarget.querySelector('i');
                    const currentType = inputEl.getAttribute('type');

                    inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                    icon.setAttribute(
                      'class',
                      currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                    );
                  }}
                >
                  <i className="glyphicon glyphicon-eye-open" />
                </span>
            </div>
            <span
              className="validationMessage"
            >This field is required.</span>
          </div>
        </div>

        <div className="checkbox">
          <label>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e: SyntheticEvent<HTMLCheckboxElement>) => {
                setRememberMe(e.target.checked);
              }}
            />
            <span>Remember me</span>
          </label>
        </div>

        <br/>

        <div className="row">
          <div className="col-xs-12 text-center progress-button-50">
            <BtnLoader
              label='Login'
              handleCallBack={async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                await sendRequest(e, setStatus);
              }}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default withMeta(Login);
